import { render, staticRenderFns } from "./caseDetail.vue?vue&type=template&id=1d61cf02"
import script from "./caseDetail.vue?vue&type=script&lang=js"
export * from "./caseDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports